import atlasAPI from '../services/atlasAPI'

export const tagsMixin = {
  data() {
    return {
      revertmyschedule: "",
      myscheduleid: "",

      tagschoosen: [],
      status: "",
      loadtags: true,
      schedule: [],
      schedulecount: 0,
      showRoom: "",
      day: ""
    };
  },
  computed: {
    tags() {
      this.tagschoosen = this.$store.getters.getTracks;
      return this.$store.getters.getTracks;
    },

  },
  methods: {
    revertSchedule: function () {
      localStorage.setItem("myscheduleid", this.revertmyschedule);
      this.myscheduleid = this.revertmyschedule;
      this.revertmyschedule = "";
      localStorage.setItem("revertmyschedule", "");
      this.$router.push({
        name: "MySchedule-id",
        params: { id: this.myscheduleid }
      });
      this.getSchedule();
    },
    async createSchedule(email) {
      const payload = {
        sessions: JSON.parse(localStorage.getItem("schedule")),
      };
      try {
        const response = await atlasAPI.post("createSchedule", payload);
        const id = response.data.insertedId;
        if (!localStorage.getItem("myscheduleid")) {
          localStorage.setItem("myscheduleid", id);
          this.myscheduleid = id;
        }
        atlasAPI.sendCreateScheduleEmail(email, id);
        this.$router.push({
          name: "MySchedule-id",
          params: { id },
        });
      } catch (error) {
        console.log(error);
      }
    },
    async getSchedule(revert) {
      let that = this;
      let lookupid = false;
      const nochange = this.$route.query.nochange;
      this.revertmyschedule = localStorage.getItem("revertmyschedule");
      this.myscheduleid = localStorage.getItem("myscheduleid")

      if (this.$route.params.id && nochange === "true") {
        // replace revertmyschedule if myscheduleid not empty
        this.revertmyschedule = this.myscheduleid || this.revertmyschedule;
        this.myscheduleid = "";
        lookupid = this.$route.params.id;
      } else if (this.$route.params.id) {
        this.myscheduleid = this.$route.params.id;
        lookupid = this.$route.params.id;
      } else {
        lookupid = this.myscheduleid;
      }

      localStorage.setItem("revertmyschedule", this.revertmyschedule);
      localStorage.setItem("myscheduleid", this.myscheduleid);

      if (!lookupid) return;
      try {
        const response = await atlasAPI.get('getSchedule?id=' + lookupid);
        if (response.data.sessions) {
          localStorage.setItem(
            "schedule",
            JSON.stringify(response.data.sessions)
          );
          this.schedule = response.data.sessions;
          this.schedulecount = this.schedule.length;
          that.$store.dispatch("counterUpdate", { count: this.schedulecount });
        }
      } catch (error) {
        console.log(error);
      }

      /* this.axios
        .get("https://admin.oredev.org/myschedule/" + lookupid)
        .then(response => {
          localStorage.setItem(
            "schedule",
            JSON.stringify(response.data.schedules[0].sessions)
          );
          this.schedule = response.data.schedules[0].sessions;
          this.schedulecount = this.schedule.length;
          that.$store.dispatch("counterUpdate", { count: that.schedulecount });
          that.loadsessions = false;
          return;
        })
        .catch(error => {
          console.log(error);
        }); */
    },
    updateSchedule: function () {
      this.myscheduleid = localStorage.getItem("myscheduleid");
      if (!this.myscheduleid) {
        return false;
      }
      const payload = {
        sessions: JSON.parse(localStorage.getItem("schedule")),
        id: this.myscheduleid
      }
      try {
        atlasAPI.put('updateSchedule', payload);
      } catch (error) {
        console.log(error);
      }

      /* this.axios
        .post("https://admin.oredev.org/methods/updateSchedule", {
          sessions: JSON.parse(localStorage.getItem("schedule")),
          scheduleid: this.myscheduleid
        })
        .then(function (response) {
          if (!localStorage.getItem("myscheduleid")) {
            localStorage.setItem("myscheduleid", response.data.id);
          }
        })
        .catch(function (error) {
          console.log(error);
        }); */
    },
    setUrlHasch: function (trigger) {

      let tagschoosen;

      // select all on first visit
      if (!localStorage.getItem("tagschoosen")) {

        if (!this.$route.query.tags) {
          this.selectAllTags();

          this.setStatus("sessions");
        }
      }

      if (localStorage.getItem("tagschoosen")) {
        tagschoosen = JSON.parse(localStorage.getItem("tagschoosen"));

      }

      let day = "day3";
      if (!localStorage.getItem("day")) {
        localStorage.setItem("day", day);
        this.day = day;
      }

      if (trigger === "mounted" && this.$route.query.tags) {

        //sätter taggar från local storage. Pausat 2024. 

        /*   if (this.$route.query.day) {
            day = this.$route.query.day;
            localStorage.setItem("day", day);
            this.day = day;
          }
          if (this.$route.query.tags) {
            let tagsArr = this.$route.query.tags.split("_");
            if (this.tags.filter) {
              this.tagschoosen = this.tags.filter(e => {
                return tagsArr.includes(e.fixed);
              });
            }
            localStorage.setItem("tagschoosen", JSON.stringify(this.tagschoosen));
            this.setStatus("sessions");
          } */
      } else {
        if (localStorage.getItem("day")) {
          day = localStorage.getItem("day");
          this.day = day;
        }

        if (tagschoosen && tagschoosen.length) {

          let fixedTags = [];
          fixedTags = tagschoosen.map(tag => {
            return tag.fixed;
          });
          this.$router.push({
            path: this.$route.path,
            query: { tags: fixedTags.join("_") /* , day: day */ }
          });
        } else {

          this.$router.push({
            path: this.$route.path,
            query: { /*tags: "" , day: day */ }
          });
        }
      }
    },
    setTag: function (eventObj) {

      // `this` inside methods points to the Vue instance
      // `event` is the native DOM event
      //event = this.fixTag(event);
      let event = {};
      if (typeof eventObj === "string") {
        event.org = eventObj;
        event.fixed = this.fixTag(eventObj);
      } else if (typeof eventObj === "object") {
        event.org = eventObj.org;
        event.fixed = eventObj.fixed;
      }

      /*       if (setSingle) {
              this.tagschoosen = []
            }
      
      
       */

      //När alla är markerade och man klickar på en så kommer bara den markeras 
      if (this.tags.length === this.tagschoosen.length) {
        this.deselectAllTags()
      }



      if (event) {

        if (this.tagschoosen.length > 0) {
          var a = [];
          a = JSON.parse(localStorage.getItem("tagschoosen"));
          const exists = a.find(function (e) {
            return e.org === event.org;
          });
          if (exists) {
            a = a.filter(function (value, index, self) {
              return value.org != event.org;
            });
          } else {
            a.push(event);
            a = a.filter(function (value, index, self) {
              return self.indexOf(value) === index;
            });
          }
          localStorage.setItem("tagschoosen", JSON.stringify(a));
        } else {
          var a = [];
          a.push(event);
          localStorage.setItem("tagschoosen", JSON.stringify(a));
        }
      }
      this.tagschoosen = a;
      if (this.tagschoosen.length === 0) {
        //this.setStatus("tags");
        this.selectAllTags()


      }
      this.setUrlHasch("tag");
    },
    deselectAllTags: function () {
      localStorage.setItem("tagschoosen", []);
      this.tagschoosen = [];
      this.setUrlHasch("none");
    },
    selectAllTags: function () {

      localStorage.setItem("tagschoosen", JSON.stringify(this.tags));
      this.tagschoosen = this.tags;
      this.setUrlHasch("all");
    },
    addOrRemove: function (id) {
      const selSchedule = this.schedule;
      let containsId = false;
      if (selSchedule) {
        containsId = selSchedule.some(element => String(element) === String(id));
      }
      if (containsId) {
        return "Remove";
      }
      return "Add";
    },
    setActiveTag: function (tag) {


      //tag = this.fixTag(tag);
      const selTags = this.tagschoosen;
      // if (!selTags.length) {
      //   return;
      // }
      const containsTag = selTags.some(element => element.org === tag.org);
      if (containsTag) {
        return "active active-" + tag.fixed.toLowerCase();
      }
    },
    setActiveNext: function () {
      if (this.tagschoosen.length === 0) {
        return "disabled";
      }
    },
    setTagsChoosen: function () {



      if (localStorage.getItem("tagschoosen")) {
        var tagschoosen = [];
        tagschoosen = JSON.parse(localStorage.getItem("tagschoosen"));


        this.tagschoosen = tagschoosen;
      }
    },
    setStatus: function (status) {
      localStorage.setItem("sessionstatus", status);
      this.status = status;
    },
    /*  fetchTags: function () {
       let that = this;
       this.axios
         .get("https://admin.oredev.org/plannedtags/Øredev 2023", {
           params: {
             //ID: 12345
           }
         })
         .then(response => {
           this.tags = response.data.map(function (tag) {
             let e = {};
             e.org = tag;
             e.fixed = that.fixTag(tag);
             return e;
           });
    
    
    
           this.loadtags = false;
           this.setUrlHasch("mounted");
         })
         .catch(error => {
           console.log(error);
         });
     }, */
    fixTag: function (tagObj) {
      let tag = "";
      if (tagObj.org) {
        tag = tagObj.org;
      } else {
        tag = tagObj;
      }
      tag = tag.replace(/\./g, "");
      tag = tag.replace(/ & /g, "-");
      tag = tag.replace(/ /g, "-");
      tag = tag.replace(/#/g, " ");

      return tag;
    },
    getDay: function (day) {
      switch (day) {
        case "0":
          day = "Sunday";
          break;
        case "1":
          day = "Monday";
          break;
        case "2":
          day = "Tuesday";
          break;
        case "3":
          day = "Wednesday";
          break;
        case "4":
          day = "Thursday";
          break;
        case "5":
          day = "Friday";
          break;
        case "6":
          day = "Saturday";
      }
      return day;
    },
    showSpeaker: function (speaker) {
      //this.showSpeaker = speaker;
      /* if (speaker) {
        this.axios
          .get("https://admin.oredev.org/plannedspeaker/" + speaker, {
            params: {
              //ID: 12345
            }
          })
          .then(response => {
            this.$store.dispatch("speakerUpdate", {
              speaker: response.data.plannedspeakers[0]
            });
            this.$root.$emit("bv::show::modal", "speaker", "#btnShow");

            return;
          })
          .catch(error => {
            console.log(error);
          });
      } */

      //this.$store.dispatch('speakerUpdate', {speaker:speaker});
      //this.$root.$emit('bv::show::modal', 'speaker', '#btnShow')
    },
    showMap: function (room) {
      if (!room) {
        room = 'map'

      }

      this.showRoom = room;
      this.$store.dispatch("maproomUpdate", { room: room });
      this.$root.$emit("bv::show::modal", "map-1", "#btnShow");
    },
    setSchedule: function (id, event) {
      if (id) {
        if (localStorage.getItem("schedule")) {
          var a = [];
          a = JSON.parse(localStorage.getItem("schedule"));
          const exists = a.find(element => String(element) === String(id));
          if (exists) {
            a = a.filter(function (value, index, self) {
              return value != id;
            });
          } else {
            a.push(String(id));
            a = a.filter(function (value, index, self) {
              return self.indexOf(value) === index;
            });
          }
          localStorage.setItem("schedule", JSON.stringify(a));
        } else {
          var a = [];
          a.push(String(id));
          localStorage.setItem("schedule", JSON.stringify(a));
        }
        this.schedule = a;
        this.schedulecount = this.schedule.length;

        /* // Counter update animation
        const counterPos = $(".my-count").offset();
        const eventPos = $(event.target).offset();
        const that = this;
        $(event.target)
          .clone()
          .prependTo("body")
          .css({ position: "absolute", top: eventPos.top, left: eventPos.left })
          .removeClass("remove add")
          .animate(
            { top: counterPos.top, left: counterPos.left },
            500,
            function () {
              $(this).remove();
              $(".my-count")
                .animate({
                  width: "100px",
                  height: "100px",
                  fontSize: "4rem",
                  lineHeight: "5.5rem"
                })
                .animate({
                  width: "30px",
                  height: "30px",
                  fontSize: "1.1rem",
                  lineHeight: "1.6rem"
                });
              that.$store.dispatch("counterUpdate", {
                count: that.schedulecount
              });
            }
          ); */
        this.$store.dispatch("counterUpdate", { count: this.schedulecount });
        this.updateSchedule();
      }
    },
    setActiveSchedule: function (id, isButton) {

      const selSchedule = this.schedule;

      let containsId = false;
      if (selSchedule) {
        containsId = selSchedule.some(element => String(element) === String(id));
      }
      if (containsId && isButton) {
        return "btn-active btn-1-active"
      }
      if (containsId) {
        return "active";
      }
    },
    toggleText: function (id) {
      $('div[data-id="' + id + '"]')
        .toggle(100)
        .removeClass("hidden");
      $('i[data-id="' + id + '"]')
        .toggle()
        .removeClass("hidden");
    }
  },

  mounted: function () {
    if (localStorage.getItem("schedule")) {
      this.schedule = JSON.parse(localStorage.getItem("schedule"));
    }
    this.schedulecount = this.schedule.length;
    this.$store.dispatch("counterUpdate", { count: this.schedule.length });
  },
  /*   beforeMount: function () {
      if (this.$route.name === "Lineup" || this.$route.name === "Sessions") {
        //this.fetchTags();
        this.tags = this.$store.getters.getTracks;
   
   
        this.loadtags = false;
        this.setUrlHasch("mounted");
   
      }
    }, */
  beforeMount: function () {


    /*    const promise = this.$store.dispatch("getAll");
       promise
         .then((e) => { */



    localStorage.setItem("tagschoosen", JSON.stringify(this.tagschoosen));

    this.loadtags = false;
    //this.setUrlHasch("mounted");

    /*     })
        .catch((e) => {
          console.log(e);
   
        })*/
  }


};





// WEBPACK FOOTER //
// ./src/mixins/tagsMixin.js